import { useEffect, useRef, useState } from 'react';

/**
 * A number that animates when its value changes — slides the new digit
 * down while fading out the old. ~200 ms, CSS-only. No external deps.
 *
 *   <AnimatedNumber value={count} />
 *
 * Reasonable for any integer-ish display where the user might notice
 * the change (sidebar badges, header counts, daily-brief tiles).
 */
export function AnimatedNumber({ value, className, style, dataTestId }) {
  const [shown, setShown] = useState(value);
  const [animating, setAnimating] = useState(false);
  const prevRef = useRef(value);

  useEffect(() => {
    if (value === prevRef.current) return undefined;
    setAnimating(true);
    const t = setTimeout(() => {
      setShown(value);
      prevRef.current = value;
      setAnimating(false);
    }, 180);
    return () => clearTimeout(t);
  }, [value]);

  return (
    <span
      data-testid={dataTestId}
      className={`pd-animated-number ${animating ? 'is-changing' : ''} ${className || ''}`}
      style={{ display: 'inline-block', ...(style || {}) }}
    >
      {shown}
    </span>
  );
}
